import { render, staticRenderFns } from "./ReportsAckFollowupDialog.vue?vue&type=template&id=1685eb45&scoped=true"
import script from "./ReportsAckFollowupDialog.vue?vue&type=script&lang=js"
export * from "./ReportsAckFollowupDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportsAckFollowupDialog.vue?vue&type=style&index=0&id=1685eb45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685eb45",
  null
  
)

export default component.exports